import React, { ReactNode, useEffect } from 'react';
import { useCookieConsent } from 'common/providers/CookieConsentProvider';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { initAnalytics } from 'scalarAnalytics/googleAnalytics';
import useAnalytics from 'scalarAnalytics/useAnalytics';

interface AnalyticsProviderProps {
  children: ReactNode;
}

const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({ children }) => {
  const [{ user }] = useStore() as unknown as UseStoreValues;
  const { consent } = useCookieConsent();

  // Only send analytics if consent.analytics is true (default to true)
  const isAnalyticsEnabled = consent?.analytics !== false;

  useEffect(() => {
    if (isAnalyticsEnabled) {
      initAnalytics(user ?? null);
    }
  }, [user, isAnalyticsEnabled]);

  useAnalytics(isAnalyticsEnabled);

  return <span>{children}</span>;
};

export default AnalyticsProvider;
